import { useState } from "react";
import { Link, createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
// import { api } from "@/lib/api/client";
import { TitleHeader } from "@/components/shared/title-header";

const SIGNUP_TITLE = `회원가입을 위해
약관동의를 먼저 진행해주세요.`;

function SignUpPage() {
  const [formData, setFormData] = useState({
    userId: "",
    phoneNumber: "",
    password: "",
    name: "",
    school: "",
    birthDate: "",
    parentName: "",
    parentPhoneNumber: "",
    parentBirthDate: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // try {
    //   const response = await api.post("/auth/signup", {
    //     ...formData,
    //     role: "student",
    //   });

    //   const data = await response.json();

    //   // 회원가입 성공
    //   if (data.accessToken) {
    //     localStorage.setItem("accessToken", data.accessToken);
    //     localStorage.setItem("user", JSON.stringify(data.user));
    //     navigate({ to: "/main" });
    //   }
    // } catch (err: any) {
    //   setError(err.message || "회원가입에 실패했습니다");
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <main className="flex min-h-screen flex-col items-center pb-10 gap-10">
      <TitleHeader title={SIGNUP_TITLE} />
      <Card className="w-full max-w-2xl">
        <CardHeader>
          <CardTitle className="text-2xl">학생 회원가입</CardTitle>
          <p className="text-sm text-muted-foreground">
            모든 정보를 정확하게 입력해주세요
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* 학생 정보 */}
            <div className="space-y-4">
              <h3 className="font-semibold text-lg">학생 정보</h3>

              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-2 md:col-span-2">
                  <Label htmlFor="userId">아이디 *</Label>
                  <Input
                    id="userId"
                    name="userId"
                    placeholder="영문, 숫자 4자 이상"
                    value={formData.userId}
                    onChange={handleChange}
                    required
                    minLength={4}
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="name">이름 *</Label>
                  <Input
                    id="name"
                    name="name"
                    placeholder="홍길동"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="phoneNumber">전화번호 *</Label>
                  <Input
                    id="phoneNumber"
                    name="phoneNumber"
                    type="tel"
                    placeholder="010-1234-5678"
                    value={formData.phoneNumber}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="school">학교 *</Label>
                  <Input
                    id="school"
                    name="school"
                    placeholder="대한중학교"
                    value={formData.school}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="birthDate">생년월일 *</Label>
                  <Input
                    id="birthDate"
                    name="birthDate"
                    type="date"
                    value={formData.birthDate}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="space-y-2 md:col-span-2">
                  <Label htmlFor="password">비밀번호 *</Label>
                  <Input
                    id="password"
                    name="password"
                    type="password"
                    placeholder="최소 6자 이상"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    minLength={6}
                  />
                </div>
              </div>
            </div>

            {/* 학부모 정보 */}
            <div className="space-y-4">
              <h3 className="font-semibold text-lg">학부모 정보</h3>

              <div className="grid gap-4 md:grid-cols-2">
                <div className="space-y-2">
                  <Label htmlFor="parentName">학부모 이름</Label>
                  <Input
                    id="parentName"
                    name="parentName"
                    placeholder="홍학부모"
                    value={formData.parentName}
                    onChange={handleChange}
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="parentPhoneNumber">학부모 전화번호</Label>
                  <Input
                    id="parentPhoneNumber"
                    name="parentPhoneNumber"
                    type="tel"
                    placeholder="010-9876-5432"
                    value={formData.parentPhoneNumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="space-y-2">
                  <Label htmlFor="parentBirthDate">학부모 생년월일</Label>
                  <Input
                    id="parentBirthDate"
                    name="parentBirthDate"
                    type="date"
                    value={formData.parentBirthDate}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            {error && (
              <div className="text-sm text-red-500 bg-red-50 p-3 rounded">
                {error}
              </div>
            )}

            <div className="space-y-4">
              <Button
                type="submit"
                className="w-full"
                size="lg"
                disabled={loading}
              >
                {loading ? "가입 중..." : "회원가입"}
              </Button>

              <div className="text-center text-sm">
                <span className="text-muted-foreground">
                  이미 계정이 있으신가요?{" "}
                </span>
                <Link
                  to="/auth/login"
                  className="text-primary hover:underline"
                >
                  로그인
                </Link>
              </div>
            </div>
          </form>
        </CardContent>
      </Card>
    </main>
  );
}

export const Route = createFileRoute("/auth/signup/")({
  component: SignUpPage,
});
